<template>
    <v-layout wrap column>
        <v-flex>
            <v-form :data-vv-scope="formScope" @submit.prevent="saveBeneficiaryInformationManagement">
                <v-expansion-panel class="panel" expand :value="panel">
                    <v-expansion-panel-content class="p-bg-red">
                        <template v-slot:header>
                            <div>
                                <span>{{ $t('basic-information') }}</span>
                            </div>
                        </template>
                        <template v-slot:actions>
                            <v-icon color="white">mdi-chevron-down</v-icon>
                        </template>
                        <v-card>
                            <v-layout pt-3 px-2 wrap>
                                <v-flex mb-3 px-2>
                                    <v-layout class="outlined-box" wrap>
                                        <label class="outlined-text bg-white">{{ $t('basic-information') }}</label>
                                        <v-flex px-2>
                                            <v-layout wrap>
                                                <v-flex md3 px-2 sm6 xs12>
                                                    <v-autocomplete :data-vv-as="$t('beneficiary-nature')"
                                                                    :error-messages="errors.collect(formScope + '.natureBeneficiary')"
                                                                    :item-text="getLabelByLang('name', 'name')"
                                                                    :items="beneficiaryNaturesList"
                                                                    :label="$t('beneficiary-nature') + ' *'"
                                                                    clearable
                                                                    :readonly="isDisabled"
                                                                    item-value="code"
                                                                    name="natureBeneficiary"
                                                                    v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary"
                                                                    @change="beneficiaryNatureChanged"
                                                                    v-validate="'required'">
                                                        <template slot="selection" slot-scope="data">
                                                            {{ $t(data.item.name) }}
                                                        </template>
                                                        <template slot="item" slot-scope="data">
                                                            {{ $t(data.item.name) }}
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex md3 px-2 sm6 xs12>
                                                    <v-text-field :data-vv-as="
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary &&
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary !== 1
                                ? $t('residence-sequence-number-and-border')
                                : $t('beneficiary-nationalNumJOR')"
                                                                  :disabled="(isDisabled && !activeSocialNumber) || disableOnEdit"
                                                                  :error-messages="errors.collect(formScope + '.beneficiaryNationalNumJOR')"
                                                                  :label="
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary &&
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary !== 1
                                ? $t('document-number') + ' *'
                                : $t('beneficiary-nationalNumJOR') + ' *'"
                                                                  :name="'beneficiaryNationalNumJOR'"
                                                                  :readonly="(isDisabled && !activeSocialNumber) || disableOnEdit"
                                                                  v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.beneficiaryNationalNumJOR"
                                                                  v-validate="'required|numeric'"
                                                                  @change="nationalNumberChanged"
                                                                  @keyup.enter="nationalNumberChanged"></v-text-field>
                                                </v-flex>

                                                <v-flex md3 px-2 sm6 xs12 v-if="beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary &&
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary === 10   ">
                                                    <v-text-field :data-vv-as="$t('registration-number')"
                                                                  :disabled="isDisabled"
                                                                  :error-messages="errors.collect(formScope + '.civilNo')"
                                                                  :label="$t('registration-number') + ' *'"
                                                                  :readonly="isDisabled || isByNatNo"
                                                                  class="mr-2"
                                                                  name="civilNo"
                                                                  v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.civilNo"
                                                                  v-validate="'max:8|required'"></v-text-field>
                                                </v-flex> <v-flex md3 px-2 sm6 xs12 v-if="beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary &&
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary === 10   ">
                                                    <v-text-field :data-vv-as="$t('Civil-location')"
                                                                  :disabled="isDisabled"
                                                                  :error-messages="errors.collect(formScope + '.civilLocation')"
                                                                  :label="$t('Civil-location') + ' *'"
                                                                  :readonly="isDisabled"
                                                                  class="mr-2"
                                                                  name="fullName"
                                                                  v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.civilLocation"
                                                                  v-validate="'max:8|required'"></v-text-field>
                                                </v-flex>
                                                <v-flex md3 px-2 sm6 xs12 v-if="1 !== 1">
                                                    <v-autocomplete :data-vv-as="$t('nationality-lookUpCode')"
                                                                    :disabled="isDisabled ? isDisabled : localDisabled"
                                                                    :error-messages="errors.collect(formScope + '.nationalityLookUpCode')"
                                                                    :item-text="getLabelByLang('name', 'name')"
                                                                    :items="nationalityList"
                                                                    :label="$t('nationality-lookUpCode') + ' *'"
                                                                    :readonly="isByNatNo || (isDisabled ? isDisabled : localDisabled)"
                                                                    clearable
                                                                    item-value="code"
                                                                    name="nationalityLookUpCode"
                                                                    v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.nationalityLookUpCode"
                                                                    v-validate="'required'"></v-autocomplete>
                                                </v-flex>
                                                <v-flex md3 sm6 xs12 v-if="
                            beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary &&
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary === 10    ">
                                                    <v-text-field :data-vv-as="$t('document-number')"
                                                                  :error-messages="errors.collect(formScope + '.passportNumber')"
                                                                  :label="$t('document-number')"
                                                                  class="mr-2"
                                                                  name="passportNumber"
                                                                  v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.passportNumber"
                                                                  v-validate="
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary &&
                              beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary !== 1
                                ? 'required|max:50'
                                : 'max:50'"></v-text-field>
                                                </v-flex>
                                                <v-flex md3 px-2 sm6 xs12>
                                                    <v-text-field :data-vv-as="$t('full-name')"
                                                                  :error-messages="errors.collect(formScope + '.fullName')"
                                                                  :label="$t('full-name') + ' *'"
                                                                  class="mr-2"
                                                                  :disabled="(isDisabled && !activeSocialNumber) || disableOnEdit"
                                                                  name="fullName"
                                                                  v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.fullName"
                                                                  v-validate="'max:50|required'"></v-text-field>
                                                </v-flex>
                                                <v-flex md3 px-2 sm6 xs12 v-if=" 1 !== 1 ">
                                                    <v-autocomplete :data-vv-as="$t('select-gender')"
                                                                    :disabled="isDisabled"
                                                                    :error-messages="errors.collect(formScope + '.gender')"
                                                                    :item-text="getLabelByLang('name', 'name')"
                                                                    :items="gendersList"
                                                                    :label="$t('select-gender') + ' *'"
                                                                    :name="'gender'"
                                                                    :readonly="isDisabled || isByNatNo"
                                                                    item-value="code"
                                                                    v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.gender"></v-autocomplete>
                                                </v-flex>
                                                <v-flex md3 px-2 sm6 xs12>
                                                    <v-autocomplete :data-vv-as="$t('social-status')"
                                                                    :disabled="isDisabled"
                                                                    :error-messages="errors.collect(formScope + '.socialStatus')"
                                                                    :item-text="getLabelByLang('name', 'name')"
                                                                    :items="socialStatusesList"
                                                                    :label="$t('social-status') + ' *'"
                                                                    :name="'socialStatus'"
                                                                    :readonly="isDisabled"
                                                                    item-value="code"
                                                                    v-model="beneficiaryInformation.savePersonalInformationDto.socialStatus"></v-autocomplete>
                                                </v-flex>
                                                <v-flex md2 px-2 sm6 xs12 v-if=" 1 !== 1 ">
                                                    <v-text-field :data-vv-as="$t('current-job')"
                                                                  :error-messages="errors.collect(formScope + '.currentJob')"
                                                                  :label="$t('current-job')"
                                                                  :name="'currentJob'"
                                                                  v-model="beneficiaryInformation.savePersonalInformationDto.currentJob"></v-text-field>
                                                </v-flex>
                                                <v-flex md5 px-2 sm6 xs12 v-if="1 !== 1">
                                                    <v-switch :color="'error'" :label="$t('dead')" v-model="beneficiaryInformation.saveBeneficiaryInformationManagementDto.deathStatus"></v-switch>
                                                </v-flex>
                                                <v-flex md3 px-2 sm6 xs12>
                                                    <v-autocomplete :data-vv-as="$t('governorate')"
                                                                    :disabled="isDisabled"
                                                                    :error-messages="errors.collect(formScope + '.governorate')"
                                                                    :item-text="getLabelByLang('name', 'name')"
                                                                    :items="governoratesList"
                                                                    :label="$t('governorate') + ' *'"
                                                                    :readonly="isDisabled"
                                                                    clearable
                                                                    item-value="code"
                                                                    name="governorate"
                                                                    v-model="beneficiaryInformation.savePersonalInformationDto.governorate"
                                                                    @change=" getBrigades($event);  getCities($event);  getJudicature($event);"
                                                                    v-validate="'required'"></v-autocomplete>
                                                </v-flex>
                                                <v-flex md3 px-2 sm6 xs12 v-if=" 1 !== 1 ">
                                                    <v-autocomplete :data-vv-as="$t('city')"
                                                                    :disabled="isDisabled"
                                                                    :error-messages="errors.collect(formScope + '.city')"
                                                                    :item-text="getLabelByLang('name', 'name')"
                                                                    :items="citiesList"
                                                                    :label="$t('city')"
                                                                    :readonly="isDisabled"
                                                                    clearable
                                                                    item-value="code"
                                                                    name="city"
                                                                    v-model="beneficiaryInformation.savePersonalInformationDto.city"></v-autocomplete>
                                                </v-flex>
                                                <v-flex md3 px-2 sm6 xs12>
                                                    <v-text-field :data-vv-as="$t('mobile-number')"
                                                                  :disabled="isDisabled"
                                                                  :error-messages="errors.collect(formScope + '.mobile1')"
                                                                  :label="$t('mobile-number')"
                                                                  :name="'mobile1'"
                                                                  :readonly="isDisabled"
                                                                  v-model="beneficiaryInformation.savePersonalInformationDto.mobile1"
                                                                  v-validate="'required|phone|max:10'"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content class="p-bg-green">
                        <template v-slot:header>
                            <div>{{ $t('attachments') }}</div>
                        </template>
                        <template v-slot:actions>
                            <v-icon color="white">mdi-chevron-down</v-icon>
                        </template>
                        <v-card>
                            <v-layout pt-3 px-2 wrap>
                                <v-flex mb-3 px-2>
                                    <v-layout class="outlined-box column" pa-3 wrap>
                                        <label class="outlined-text bg-white">{{ $t('attachments') }}</label>
                                        <v-layout>
                                            <v-flex md4 px-2 sm6 xs12>
                                                <v-autocomplete :data-vv-as="$t('attachment-type')"
                                                                :error-messages="errors.collect(formScope + '.attachmentType')"
                                                                :item-text="'fileName'"
                                                                :items="attachmentTypesList"
                                                                :label="$t('attachment-type')"
                                                                clearable
                                                                return-object
                                                                name="attachmentType"
                                                                v-model="fileCategory"></v-autocomplete>
                                            </v-flex>
                                            <v-btn @click="saveCategoryLocal()" color="green" dark>
                                                {{ $t('add-more') }}
                                            </v-btn>
                                        </v-layout>
                                        <v-layout v-if="files.length > 0" mb-3>
                                            <files-viewer :files="files" @removeFileEmitter="removeFile" />
                                        </v-layout>
                                        <v-layout>
                                            <uploader :uploadedList.sync="uploadedList"
                                                      :dropzoneId="'beneficiaryInfoDropzoneId'"
                                                      :filesList="filesList"
                                                      :treeId="treeId" />
                                        </v-layout>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-layout class="px-2 mb-2" wrap>
                    <v-btn type="submit" color="green" v-if=" ($route.name !== 'add-service-details') && savePermission" dark>
                        {{ this.$store.getters.user.source === 4 && this.$route.params.from === '3'? $t('send-request') : $t('save') }}
                    </v-btn>
                    <v-btn v-if="($route.name !== 'add-service-details') && !this.$route.params.taskId" :to="{ name: this.$store.getters.user.source !== 4 ? 'aid-information-list' : 'system-landing-page' }"
                           color="red"
                           dark>
                        {{ $t('cancel') }}
                    </v-btn>
                </v-layout>
            </v-form>
        </v-flex>
        <v-layout wrap v-if="($route.params.taskId || $route.params.from === '2') && !$route.params.beneficiaryInformationId">
            <actions-bar />
        </v-layout>
    </v-layout>
</template>

<script>
    import AuthService from '@/services/AuthServices';
    import { mapGetters } from 'vuex';
    import BeneficiaryInformationManagementService from '@/services/Disabilities/PersonWithDisabilities/BeneficiaryInformationManagement/BeneficiaryInformationManagement/BeneficiaryInformationManagementService';
    import LookUpService from '@/services/LookUpService';
    import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';
    import PageService from '@/services/Archiving/InstancePageService';
    const Uploader = () => import('@/views/Directorate/Shared/Uploader.vue');
    const FilesViewer = () => import('@/views/Directorate/Shared/FilesViewer.vue');
    import FileCategoryService from '@/services/FileCategoryService';
    const ActionsBar = () => import('@/views/ActionsBar.vue');
    export default {
        name: 'aid-information',
        props: {
            panel: { type: Array, required: false, default: () => [[true], [true], [true]] },
            isDisabled: { type: Boolean, required: false, default: false }, // To Disable All Fields
            isUploading: { type: Boolean, required: false, default: true }, // To Use Uploader
            activeSocialNumber: { type: Boolean, required: false, default: true },
            hideAllExceptInformation: { type: Boolean, required: false, default: false },
            showBasic: { type: Boolean, required: false, default: false },
            formScope: {
                type: String,
                required: false,
                default: 'beneficiaryInformation'
            }
        },
        data: () => ({
            beneficiaryInformation: {
                saveBeneficiaryInformationManagementDto: {
                    beneficiaryNationalNumJOR: null,
                    nationalityLookUpCode: '001',
                    passportNumber: '',
                    passportExpiryDate: '',
                    fullName: null,
                    gender: 1,
                    nationalNumforMUM: null,
                    bod: null,
                    country: '1',
                    city: '',
                    locationOfBirth: '',
                    nameMUM: null,
                    natureBeneficiary: null,
                    natureBirth: '',
                    babyNeed: '',
                    lenghthPregnancy: '',
                    identifierNationalNumJOR: '',
                    natureofIdentifier: 0,
                    causesOfDisability: '',
                    typeOfDisability: '0',
                    deathStatus: false,
                    fatherNationalNo: null,
                    civilNo: null,
                    civilLocation: null,
                    infoOfficer: '',
                },
                savePersonalInformationDto: {
                    socialStatus: null,
                    educationalLevel: '6',
                    healthInsuranceType: '',
                    region: null,
                    governorate: null,
                    majorGeneral: '',
                    judicature: '',
                    city: '',
                    village: '',
                    neighborhood: '',
                    streetName: '',
                    buildingNumber: '',
                    mobile1: '',
                    mobile2: '',
                    email: '',
                    identifierNationalNumJOR: '',
                    natureofIdentifier: 0,
                    jobSector: '',
                    currentJob: '',
                    identifierName: ''
                },
                lstSaveFileCategoryDto: [],
            },

            gendersList: [],
            nationalityList: [],
            countriesList: [],
            regionsList: [],
            governoratesList: [],
            brigadesList: [],
            judicatureList: [],
            citiesList: [],
            birthLocationsList: [],
            socialStatusesList: [],
            attachmentTypesList: [],
            beneficiaryNaturesList: [],
            identifierNaturesList: [],
            birthNaturesList: [],
            babyConditionsList: [],
            pregnancyDurationsList: [],
            datepickerEx: false,
            datepicker: false,
            fileCategory: null, // current uploaded files category
            files: [], // Just For Preview On Init get files & save them in it
            uploadedList: [], // Saved Files In Uploader Weather Success or failed
            filesList: [], // Saved Success Files That Exist In Uploader
            fileCategoriesList: [], // to save files with its categories if all currect save categories in beneficiaryInformation and then save files
            treeId: 181,
            localDisabled: false,
            memberAge: null,
            isLoading: false,
            disabilityCausesEditIndex: null,
            disableOnEdit: false,
            hideAllExceptInformationLocal: true,
            savePermission: false,
            isByNatNo: false,
        }),
        async created() {
            if (this.$route.params.from === '3' || this.$store.getters.user.source === 4) {
                this.hideAllExceptInformationLocal = false;
            }

            this.isLoading = true;
            this.$store.dispatch('showLoading');
            await this.getBeneficiaryNatures();
            await this.getGenders();
            await this.getNationlites();
            await this.getSocialStatuses();
            await this.getAttachmentTypes();
            await this.getCountries();
            await this.getGovernorates();
            await this.dataInit();
            if (this.$route.params.taskId > 0) {
                this.isDisabled = true;
                this.disableOnEdit = true;
            }
            this.$store.dispatch('hideLoading');
            this.isLoading = false;
        },
        methods: {
            async dataInit(beneficiaryNationalNumJOR = null) {
                const pagesData = (await AuthService.getPageActions('202')).data;
                if (pagesData) {
                    pagesData.lstActions.forEach(item => {
                        if (item.toString() === '2') {
                            this.savePermission = true;
                        }
                        if (item.toString() === '3') {
                            this.savePermission = true;
                        }
                    });
                }

                const beneficiaryInformationManagementId = this.$route.params.beneficiaryInformationId
                    ? this.$route.params.beneficiaryInformationId
                    : this.$route.params.id;

                this.disableOnEdit =
                    !this.$route.params.beneficiaryInformationId && this.$route.params.id && this.$route.params.id > 0
                        ? true
                        : false;

                if (beneficiaryInformationManagementId || beneficiaryNationalNumJOR) {
                    let beneficiaryInformationManagement = null;
                    if (beneficiaryInformationManagementId) {
                        beneficiaryInformationManagement = (await BeneficiaryInformationManagementService.getAllBeneficiaryInformationManagements({
                            keyword: '',
                            id: beneficiaryInformationManagementId,
                        })).data;
                    }
                    else
                        beneficiaryInformationManagement = (await BeneficiaryInformationManagementService.getAllBeneficiaryInformationManagements({
                            keyword: '',
                            beneficiaryNationalNumJOR: beneficiaryNationalNumJOR,
                            natureBeneficiary: this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary,
                        })).data;

                    if (!beneficiaryInformationManagement && !beneficiaryNationalNumJOR) this.$router.push({ name: 'aid-information-list' });
                    if (beneficiaryInformationManagement) {
                        this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.nationalityLookUpCode = "001";// beneficiaryInformationManagement.getBeneficiaryInformationManagementDto.nationalityLookUpCode;
                        if (
                            (beneficiaryNationalNumJOR && beneficiaryInformationManagement.getBeneficiaryInformationManagementDto) ||
                            !beneficiaryNationalNumJOR
                        ) {
                            this.beneficiaryInformation = {
                                saveBeneficiaryInformationManagementDto: { ...beneficiaryInformationManagement.getBeneficiaryInformationManagementDto },
                                savePersonalInformationDto: { ...beneficiaryInformationManagement.getPersonalInformationDto },
                                lstSavePersonsDisabilitiesInFamilyDto: beneficiaryInformationManagement.lstGetPersonsDisabilitiesInFamilyDto
                                    ? beneficiaryInformationManagement.lstGetPersonsDisabilitiesInFamilyDto
                                    : [],
                                lstSaveCausesOfDisabilityDto: beneficiaryInformationManagement.lstGetCausesOfDisabilityDto
                                    ? beneficiaryInformationManagement.lstGetCausesOfDisabilityDto
                                    : [],
                                lstSaveHealthProblemsDto: beneficiaryInformationManagement.lstGetHealthProblemsDto
                                    ? beneficiaryInformationManagement.lstGetHealthProblemsDto
                                    : [],
                                lstSaveFileCategoryDto: []
                            };

                            await this.getCities(this.beneficiaryInformation.savePersonalInformationDto.governorate);
                            this.diseasesInFamilyList = beneficiaryInformationManagement.lstGetDiagonisisInformationDto
                                ? beneficiaryInformationManagement.lstGetDiagonisisInformationDto : [];
                            this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureofIdentifier = this.beneficiaryInformation.savePersonalInformationDto.natureofIdentifier;
                            this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.identifierNationalNumJOR = this.beneficiaryInformation.savePersonalInformationDto.identifierNationalNumJOR;
                            if (this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.bod)
                                this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.bod = this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.bod.substr(
                                    0, 10);
                            if (this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.passportExpiryDate)
                                this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.passportExpiryDate = this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.passportExpiryDate.substr(
                                    0, 10);
                            if (this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary == 1) {
                                this.isByNatNo = true;
                            } else {
                                this.isByNatNo = false;
                            }
                            if (
                                this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.msg !== null &&
                                this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.msg !== ''
                            ) {
                                this.$store.dispatch('showMessage', {
                                    text: this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.msg,
                                    color: 'error'
                                });
                                if (this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.id) {
                                    const beneficaryIndex = this.beneficiaryInformation.lstSavePersonsDisabilitiesInFamilyDto.findIndex(
                                        item => item.beneficiaryInfoId === this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.id
                                    );
                                    if (beneficaryIndex !== -1) {
                                        const disabilityNatures = this.beneficiaryInformation.lstSavePersonsDisabilitiesInFamilyDto[
                                            beneficaryIndex
                                        ].natureOfDisability.split(';');
                                        disabilityNatures.forEach(item => {
                                            if (this.selectedDisabilityNatures.findIndex(selectedItem => selectedItem.code === item.toString()) === -1) {
                                                const natureItem = this.disabilityNaturesList.find(nature => nature.code === item.toString());
                                                if (natureItem) this.selectedDisabilityNatures.push(natureItem);
                                            }
                                        });
                                    }
                                }
                            }

                            //this.selectedDisabilityType = [];
                            //if (this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.typeOfDisability) {
                            //    const disabilityTypeList = this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.typeOfDisability.split(';');
                            //    disabilityTypeList.forEach(item => {
                            //        if (this.selectedDisabilityType.findIndex(selectedItem => selectedItem.code === item.toString()) === -1) {
                            //            const natureItem = this.disabilityNaturesList.find(nature => nature.code === item.toString());
                            //            if (natureItem) this.selectedDisabilityType.push(natureItem);
                            //        }
                            //    });
                            //}

                            //if (beneficiaryInformationManagement.getBeneficiaryInformationManagementDto.id == 0 && this.$store.getters.user.source === 4) {
                            //    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.fullName = this.$store.getters.user.arFullName;
                            //    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.gender = this.$store.getters.user.gender.toString();
                            //    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.bod = this.$store.getters.user.bod.substr(0, 10);
                            //    this.beneficiaryInformation.savePersonalInformationDto.governorate = this.$store.getters.user.governorate;
                            //    this.getCities(this.beneficiaryInformation.savePersonalInformationDto.governorate);
                            //    this.beneficiaryInformation.savePersonalInformationDto.city = this.$store.getters.user.city;
                            //    this.beneficiaryInformation.savePersonalInformationDto.mobile1 = this.$store.getters.user.mobile;
                            //    this.beneficiaryInformation.savePersonalInformationDto.email = this.$store.getters.user.email;
                            //}

                            this.$emit('beneficiaryInformation', this.beneficiaryInformation);
                            this.getUploadedFiles();
                        }
                    } else {
                        //if (this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.id == 0 && this.$store.getters.user.source === 4) {
                        //    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.fullName = this.$store.getters.user.arFullName;
                        //    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.gender = this.$store.getters.user.gender.toString();
                        //    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.bod = this.$store.getters.user.bod.substr(0, 10);
                        //    this.beneficiaryInformation.savePersonalInformationDto.governorate = this.$store.getters.user.governorate;
                        //    this.getCities(this.beneficiaryInformation.savePersonalInformationDto.governorate);
                        //    this.beneficiaryInformation.savePersonalInformationDto.city = this.$store.getters.user.city;
                        //    this.beneficiaryInformation.savePersonalInformationDto.mobile1 = this.$store.getters.user.mobile;
                        //    this.beneficiaryInformation.savePersonalInformationDto.email = this.$store.getters.user.email;
                        //}
                    }
                } else {
                    if (this.$store.getters.user.source === 4) {
                        //this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.fullName = this.$store.getters.user.arFullName;
                        //this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.gender = this.$store.getters.user.gender.toString();
                        //this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.bod = this.$store.getters.user.bod.substr(0, 10);
                        //this.beneficiaryInformation.savePersonalInformationDto.governorate = this.$store.getters.user.governorate;
                        //this.getCities(this.beneficiaryInformation.savePersonalInformationDto.governorate);
                        //this.beneficiaryInformation.savePersonalInformationDto.city = this.$store.getters.user.city;
                        //this.beneficiaryInformation.savePersonalInformationDto.mobile1 = this.$store.getters.user.mobile;
                        //this.beneficiaryInformation.savePersonalInformationDto.email = this.$store.getters.user.email;
                    }
                }
            },
            async GetCSPDNameBYNationalNum(NationalNum) {
                const result = await BeneficiaryInformationManagementService.GetCSPDNameBYNationalNum(NationalNum);
                this.beneficiaryInformation.savePersonalInformationDto.identifierName = result.data;
            },
            nationalNumberChanged() {
                if (!this.beneficiaryInformation.id && this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.beneficiaryNationalNumJOR) {
                    this.isByNatNo = true;
                    this.dataInit(this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.beneficiaryNationalNumJOR);
                }
            },
            async startWorkflow() {
                this.$store.dispatch('showLoading');
                const result = await BeneficiaryInformationManagementService.startWF({
                    applicationId: this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.id,
                    processId: 61
                });
                if (result.data.statusCode === 200) {
                    this.$store.dispatch('showMessage', { text: result.data.message });
                } else
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                this.$store.dispatch('hideLoading');
            },
            /* save Beneficiary Information */
            async saveBeneficiaryInformationManagement() {
                const beneficiaryInformationValid = await this.$validator.validateAll(this.formScope);
                this.attachmentTypesList.forEach(element => {
                    const fileCategoryIndex = this.files.findIndex(item => item.fileCategoryId === element.id);
                    if (element.isMandatory && fileCategoryIndex === -1) {
                        this.$store.dispatch('showMessage', { text: 'حمل المرفقات الاجبارية', color: 'warning' });
                        return;
                    }
                });
                if (beneficiaryInformationValid) {
                    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.bod = new Date().toISOString().substr(0, 10);
                    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.nameMUM = "Mother Name";
                    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.nationalNumforMUM = "0";
                    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.nationalityLookUpCode = "001";
                    this.beneficiaryInformation.savePersonalInformationDto.natureofIdentifier = this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureofIdentifier;
                    this.beneficiaryInformation.savePersonalInformationDto.identifierNationalNumJOR = this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.identifierNationalNumJOR;
                    const failedFiles = this.filesList.filter(item => item.status === 'error');
                    const inProgressFiles = this.filesList.filter(item => item.status === 'uploading' || item.status === 'queued');

                    if (failedFiles.length > 0) {
                        this.$store.dispatch('showMessage', {
                            text: this.$t('some-files-failed-to-upload'),
                            color: 'error'
                        });
                        return;
                    }

                    if (inProgressFiles.length > 0) {
                        this.$store.dispatch('showMessage', {
                            text: this.$t('some-files-in-progress-upload'),
                            color: 'warning'
                        });
                        return;
                    }

                    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.typeOfDisability = '';
                    this.beneficiaryInformation.savePersonalInformationDto.educationalLevel = "6";
                    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.country = "1";
                    if (this.beneficiaryInformation.savePersonalInformationDto.natureBeneficiary !== "1") {
                        this.beneficiaryInformation.savePersonalInformationDto.gender = "1";
                    }
                    this.$store.dispatch('showLoading');
                    if (this.beneficiaryInformation.savePersonalInformationDto.typeOfDisability === '') {
                        this.beneficiaryInformation.savePersonalInformationDto.typeOfDisability = '0';
                    }

                    const result = await BeneficiaryInformationManagementService.SaveAidInformation(this.beneficiaryInformation);

                    if (result.data.statusCode === 200) {
                        const instanceId = parseInt(result.data.id, 10);
                        this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.id = instanceId;
                        const result2 = await this.startWorkflow();
                        if (this.fileCategoriesList.length > 0) {
                            this.fileCategoriesList.forEach(item => this.finalSaveFileForm(instanceId, item));
                            this.fileCategoriesList.forEach(categoryItem => {
                                categoryItem.uploadedFiles.forEach(item => this.finalSaveFileForm(instanceId, categoryItem.id, item.response)); // this
                            });
                        }

                       
                        //if (this.$route.params.taskId)
                        //    await ProcessTaskService.saveSubApplicationID({ id: this.$route.params.taskId, subApplicationID: instanceId });
                         
                        this.$store.dispatch('showMessage', { text: result.data.message });
                    } else
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            color: 'error'
                        });
                    this.$store.dispatch('hideLoading');
                }
            },
            /*File Operation*/
            saveCategoryLocal() {
                if (!this.fileCategory) {
                    this.$store.dispatch('showMessage', {
                        text: this.$t('please-select-attachment-type-first'),
                        color: 'error'
                    });
                    return;
                }
                const failedFiles = this.filesList.filter(item => item.status === 'error');
                const inProgressFiles = this.filesList.filter(item => item.status === 'uploading' || item.status === 'queued');
                if (failedFiles.length > 0) {
                    this.$store.dispatch('showMessage', {
                        text: this.$t('some-files-failed-to-upload'),
                        color: 'error'
                    });
                    return;
                }
                if (inProgressFiles.length > 0) {
                    this.$store.dispatch('showMessage', {
                        text: this.$t('some-files-in-progress-upload'),
                        color: 'warning'
                    });
                    return;
                }
                if (this.fileCategory.isMandatory && this.uploadedList.length === 0) {
                    this.$store.dispatch('showMessage', {
                        text: this.$t('please-upload-attachments-first'),
                        color: 'warning'
                    });
                    return;
                }

                this.fileCategoriesList.push({ ...this.fileCategory, uploadedFiles: this.uploadedList });
                this.uploadedList.forEach(element => {
                    this.files.push({
                        fileCategoryId: this.fileCategory.id,
                        uuid: element.file.upload.uuid,
                        url: element.response.vPath,
                        type: element.response.fileExtension,
                        categoryName: this.fileCategory.fileName
                    });
                });

                this.uploadedList = [];
                this.fileCategory = null;
            },
            async getUploadedFiles() {
                this.files = [];
                const beneficiaryInformationManagementId = this.$route.params.beneficiaryInformationId
                    ? this.$route.params.beneficiaryInformationId
                    : this.$route.params.id;

                const uploadedFilesList = (await PageService.getPages({
                    treeId: this.treeId,
                    instanceId: beneficiaryInformationManagementId,
                    keyWord: ''
                })).data;
                uploadedFilesList.forEach(element => {
                    this.beneficiaryInformation.lstSaveFileCategoryDto.push({ filCategoryId: element.fileCategoryId });
                    this.files.push({
                        id: element.id,
                        url: element.path,
                        type: element.fileExtension,
                        fileCategoryId: element.fileCategoryId,
                        beneficiaryInformationId: beneficiaryInformationManagementId,
                        categoryName: element.arLabel
                    });
                });
            },
            async finalSaveFileForm(instanceId, fileCategory) {
                const saveFileTODB = fileCategory.uploadedFiles;
                saveFileTODB.forEach(element => {
                    const fileIndex = this.files.findIndex(item => item.uuid === element.file.upload.uuid);
                    const pageBody = {
                        arLabel: this.files[fileIndex].categoryName,
                        enLabel: this.files[fileIndex].categoryName,
                        instanceId: instanceId,
                        path: element.response.aPath,
                        id: 0,
                        treeId: this.treeId,
                        tag: '',
                        OriginalId: 0,
                        versionNo: 0,
                        fileExtension: element.response.fileExtension,
                        fileCategoryId: this.files[fileIndex].fileCategoryId //this
                    };
                    const res = (PageService.savePage(pageBody, this.treeId)).data;
                    if (res.statusCode !== 200)
                        this.$store.dispatch('showMessage', {
                            text: res.message,
                            color: 'error'
                        });
                });
            },
            removeFile(fileIndex) {
                // remove if file saved
                if (this.files[fileIndex].beneficiaryInformationId && this.files[fileIndex].id) {
                    this.$store.dispatch('confirm');
                    ConfirmationEvent.$on('onSuccess', async () => {
                        const body = [
                            {
                                treeId: this.treeId,
                                instanceId: this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.id,
                                id: this.files[fileIndex].id
                            }
                        ];
                        const res = (await PageService.deletePages(body)).data;
                        if (res.statusCode === 200) {
                            const categoryIndex = this.beneficiaryInformation.lstSaveFileCategoryDto.findIndex(
                                item => item.id === this.files[fileIndex].id
                            );
                            this.beneficiaryInformation.lstSaveFileCategoryDto.splice(categoryIndex, 1);
                            this.$store.dispatch('showMessage', { text: res.message });
                        } else {
                            this.$store.dispatch('showMessage', {
                                text: res.message,
                                color: 'error'
                            });
                        }
                    });
                }

                // this remove item before save
                if (this.files[fileIndex].fileCategoryId) {
                    const fileCategoryIndex = this.fileCategoriesList.findIndex(item => item.id === this.files[fileIndex].fileCategoryId);
                    const fileIndexInCategory = this.fileCategoriesList[fileCategoryIndex].uploadedFiles.findIndex(
                        item => item.file.upload.uuid === this.files[fileIndex].uuid
                    );

                    this.fileCategoriesList[fileCategoryIndex].uploadedFiles.splice(fileIndexInCategory, 1);
                    this.files.splice(fileIndex, 1);
                }
            },
            /*end file operation*/
            beneficiaryNatureChanged() {
                if (this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.natureBeneficiary === 1) {
                    this.localDisabled = true;
                    this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.nationalityLookUpCode = '001';
                } else this.localDisabled = false;
            },
            async getGenders() {
                this.gendersList = (await LookUpService.getLookup(59)).data;
            },
            async getNationlites() {
                this.nationalityList = (await LookUpService.getLookup(55)).data;
            },
            async getCountries() {
                this.countriesList = (await LookUpService.getLookup(55)).data;
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
            async getBrigades(code) {
                if (code && code !== '0') {
                    const selectedItem = this.governoratesList.find(item => item.code === code);
                    const result = await LookUpService.getLookupByParentId(selectedItem.id, 89);
                    if (result.data) this.brigadesList = result.data;
                    else this.brigadesList = [];
                } else this.brigadesList = [];
            },
            async getJudicature(code) {
                if (code && code !== '0') {
                    const result = await LookUpService.getLookupByParentId(code, 96);
                    if (result.data) this.judicatureList = result.data;
                    else this.judicatureList = [];
                } else this.judicatureList = [];
            },
            async getCities(code) {
                if (code && code !== '0') {
                    const result = await LookUpService.getLookupByParentId(code, 100);
                    if (result.data) this.citiesList = result.data;
                    else this.citiesList = [];
                } else this.citiesList = [];
            },
            async getBirthLocations() {
                this.birthLocationsList = (await LookUpService.getLookup(222)).data;
            },
            async getSocialStatuses() {
                this.socialStatusesList = (await LookUpService.getLookup(77)).data;
            },
            async getEducationalLevels() {
                this.educationalLevelsList = (await LookUpService.getLookup(54)).data;
            },
            async getAttachmentTypes() {
                this.attachmentTypesList = (await FileCategoryService.getFileCategoryByCriteria({ keyword: '', pageCodeID: 202 })).data;
            },
            getBeneficiaryNatures() {
                this.beneficiaryNaturesList.push(
                    {
                        code: 1,
                        name: 'jordanian'
                    },
                    {
                        code: 2,
                        name: 'non-jordanian'
                    },
                    {
                        code: 3,
                        name: 'jordanians-sons'
                    },
                    {
                        code: 4,
                        name: 'Gaza-sons'
                    }
                );
            },
        },
        computed: {
            ...mapGetters(['permissions'])
        },
        components: { Uploader, FilesViewer, ActionsBar },
        watch: {
            beneficiaryInformation: function () {
                this.$emit('beneficiaryInformation', this.beneficiaryInformation);
            }
        }
    };
</script> 